import { css } from '@linaria/core';
import { LegacyTeaserLabel } from '../primitives';
export const LiveOverline = {
    base: css `
		color: rgb(var(--brand-live));
	`,
};
export const SublineWrapper = {
    base: css `
		display: flex;
		flex-wrap: wrap;
		align-items: center;

		width: calc(100% - 38px);
		margin-bottom: 6px;

		.${LegacyTeaserLabel.base} {
			color: rgb(var(--global-surface));
			background-color: rgba(var(--global-text), 0.8);
			transition: all 0ms;

			@media (hover: hover) and (pointer: fine) {
				position: absolute;
			}
		}

		> div:first-child {
			margin-right: 8px;
		}
	`,
};
export const Text = {
    base: css `
		overflow: hidden;
		display: block;
		-webkit-box-orient: vertical;
		-webkit-line-clamp: 5;

		max-height: calc(1em * 1.2em * 5); /* Schriftgröße * line-height * Zeilen */

		text-overflow: ellipsis;

		/* TODO: Teasertext darf nicht grundsätzlich auf 5 Zeilen trunkiert werden */
	`,
};
export const LabelWrapper = {
    base: css `
		display: flex;
	`,
};
